import React from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { CheckBox } from '../../../../components/CheckBox'
import { corporateColor, lightBackground, NECROPSY_STATE, white } from '../../../../theme/colors'
import { DataForm } from '../../../../context/Necropsy/types'
import { MoreIcon } from '../../../../components/Svg'

interface Props {
  item: DataForm
  isCheck: boolean
  hasBg: boolean
  onSelect: (item: DataForm) => void
  onNavigate: (id: string) => void
}

const STATUS_FORM = {
  sent: 'Enviado',
  pending: 'No enviado',
  sending: 'Sincronizando',
}

export const Item = ({ item, isCheck, onSelect, hasBg, onNavigate }: Props) => {
  return (
    <View style={[style.container, hasBg && { backgroundColor: lightBackground }]}>
      <View style={style.headerContainer}>
        <View style={{ flex: 1 }}>
          <CheckBox
            isCheck={isCheck}
            item={{ id: item.cageId!, name: item.cageName! }}
            onPress={() => onSelect(item)}
          />
        </View>
        <TouchableOpacity onPress={() => onNavigate(item.formId!)}>
          <MoreIcon height={24} width={24} />
        </TouchableOpacity>
      </View>
      <View style={{ flexDirection: 'row' }}>
        <View style={{ flex: 1.5 }}>
          <Text style={[style.stateTitle, { color: NECROPSY_STATE[item.stateForm!] }]}>
            Estado: {STATUS_FORM[item.stateForm!]}
          </Text>
          <Text style={style.label}>Centro: {item.centerName}</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={style.label}>Fecha: {item.date}</Text>
          <Text style={style.label}>Hora: {item.time}</Text>
        </View>
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    paddingVertical: 16,
    backgroundColor: white,
  },
  headerContainer: { justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center' },
  stateTitle: {
    fontSize: 16,
    fontWeight: '500',
  },
  label: {
    fontSize: 16,
    fontWeight: '400',
    color: corporateColor,
  },
})
